const controller = "user";

export default {
  controller,
  login: controller + "/login",
  basicInfo: controller + "/basic-info",
};
